import { put, select, takeLatest } from 'redux-saga/effects'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { getImmobilizationSelector } from '../../procedures/immobilization/selectors'
import { IImmobilizationState } from '../../procedures/immobilization/store/immobilization.types'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, ITimelineState } from '../store/timeline.types'
import { generateClientCorrelationId } from '../../nemsisData/utils/customElements.util'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'

export function* addImmobilizationItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { items } = timeline
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)
  const immobilizationState: IImmobilizationState = yield select(getImmobilizationSelector)
  const {
    pta,
    addToTimeline,
    site,
    assessment,
    devicesUsed,
    option,
    key,
    time,
    date,
    assessedBy,
    comments,
    isEkgImport,
    action,
  } = immobilizationState
  if (addToTimeline) {
    const clientCorrelationId = generateClientCorrelationId(
      nemsisCodeOptions,
      TimelineConstants.IMMOBILIZATION_PROCEDURE,
      action?.name || '',
      {
        filter1: null,
        filter2: null,
        filter3: null,
      },
      key
    )
    const siteLabel = site.map((option) => option.name).toString()
    const assessmentLabel = assessment.map((option) => option.name).toString()
    const devicesUsedLabel = devicesUsed.map((option) => option.name).toString()
    const index = items.findIndex((item) => item.key === key)
    const dateTime = new Date(date || 0)
    if (time) {
      if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
      dateTime.setMinutes(+time.split(':')[1])
      dateTime.setHours(+time.split(':')[0])
    }
    const item: IItem = {
      key: key,
      clientCorrelationId,
      grid: true,
      labelHeaderFlag: pta ? 'PTA' : '',
      labelHeader: time,
      subHeader: date,
      itemType: 'Procedures',
      event: 'Immobilization',
      eventSubHeader: `By ${assessedBy?.name || ''}, Option: ${option?.name || ''}, Devices Used: ${devicesUsedLabel},
      Assessment: ${assessmentLabel}, Site: ${siteLabel}, Comments: ${comments}.`,
      rowActionType: TimelineConstants.SET_IMMOBILIZATION_PROCEDURE_ITEM,
      defaultHref: TabConstants.IMMOBILIZATION_PROCEDURE,
      date: dateTime,
      ...(isEkgImport && { isEkgImport: isEkgImport }),
    }
    if (index !== -1) {
      items[index] = item
    } else {
      items.push(item)
    }
    yield put(setActivityLog(items))
    yield put(saveTimelineItems())
  }
}

export function* addImmobilizationItemSaga() {
  yield takeLatest([TimelineConstants.ADD_IMMOBILIZATION_ITEM], addImmobilizationItem)
}
